/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserArtistCoinBadge
 */
export interface UserArtistCoinBadge {
    /**
     * 
     * @type {string}
     * @memberof UserArtistCoinBadge
     */
    mint?: string;
    /**
     * 
     * @type {string}
     * @memberof UserArtistCoinBadge
     */
    logoUri?: string;
    /**
     * 
     * @type {string}
     * @memberof UserArtistCoinBadge
     */
    bannerImageUrl?: string;
    /**
     * The coin symbol/ticker
     * @type {string}
     * @memberof UserArtistCoinBadge
     */
    ticker?: string;
}

/**
 * Check if a given object implements the UserArtistCoinBadge interface.
 */
export function instanceOfUserArtistCoinBadge(value: object): value is UserArtistCoinBadge {
    let isInstance = true;

    return isInstance;
}

export function UserArtistCoinBadgeFromJSON(json: any): UserArtistCoinBadge {
    return UserArtistCoinBadgeFromJSONTyped(json, false);
}

export function UserArtistCoinBadgeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserArtistCoinBadge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mint': !exists(json, 'mint') ? undefined : json['mint'],
        'logoUri': !exists(json, 'logo_uri') ? undefined : json['logo_uri'],
        'bannerImageUrl': !exists(json, 'banner_image_url') ? undefined : json['banner_image_url'],
        'ticker': !exists(json, 'ticker') ? undefined : json['ticker'],
    };
}

export function UserArtistCoinBadgeToJSON(value?: UserArtistCoinBadge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mint': value.mint,
        'logo_uri': value.logoUri,
        'banner_image_url': value.bannerImageUrl,
        'ticker': value.ticker,
    };
}

